
  <!-- Header -->
  <div style="margin-bottom: 1rem;">
    <div class="header-row">
      <div style="margin-bottom: 1rem;">
      <label
        i18n="@@CreateSignal"
        class="textColour"
        [ngStyle]="{ 'border-color': buttonColor }"
      >
        {{ titleText }}
      </label>
      </div>

      <!-- <span class="example-spacer"></span> -->

      <!-- NEW PRODUCT DROPDOWN -->
       <div style="display:contents" *ngIf="showProductSelection && !EditingMode">
    <mat-form-field appearance="outline" class="product-dropdown">
      <mat-label>Select Product</mat-label>

      <mat-select
        [(value)]="selectedProduct"
        (selectionChange)="onProductChange($event.value)"
      >
        <mat-option *ngFor="let product of productsDisplayed"
                    [value]="product">
          {{ product.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- New Pss Selection  -->
     
    <!-- This below Pss Drop is commented Due to feedBack We dont requires Activity Drop Down
          Signals To be created for each activity in review Activity Screen 
          @date :- 16/03/26   -->

    <!-- ACTIVITY DROPDOWN -->
<!-- <div *ngIf="selectedProduct">
  <mat-form-field appearance="outline"  class="product-dropdown">
    <mat-label>Select Product Strategy</mat-label>

    <mat-select
      [(value)]="selectedScheduleId"
      (selectionChange)="patchMetadata($event.value)"
    > -->

      <!-- NONE OPTION -->
      <!-- <mat-option value="NONE">None</mat-option> -->


      <!-- PSS + ACTIVITY OPTIONS -->
      <!-- <mat-option *ngFor="let item of signalProducts"
                  [value]="item"  
                  class="pss-option">
       <div class="option-wrapper">
            <div class="option-title">
              {{ item.strategyName }}<span class="version-badge">  v{{ item.version }}</span>
            </div> -->
            <!-- <div class="option-title">
              <span class="activity-badge">Activity : {{ item.activityName }}</span>
            </div> -->
          <!-- </div>
      </mat-option>

    </mat-select>
  </mat-form-field>
</div> -->

    </div>
    </div>
        <ng-template #noProducts>
  <div class="no-data">
    No signal detected products are available.
  </div>
</ng-template>
  </div>

<!-- READONLY SUMMARY SECTION -->
<div *ngIf="signalProducts  && !EditingMode" class="summary-grid">

   <!-- PRODUCT LEVEL (When None Selected) -->
  <ng-container *ngIf="showProductSelection; else activityBlock">

    <div class="summary-item">
      <label>Product Name</label>
      <div class="value">{{ productMeta?.productName }}</div>
    </div>

    <div class="summary-item">
      <label>Product Type</label>
      <div class="value">{{ productMeta?.producttype }}</div>
    </div>

    <div class="summary-item">
      <label>IBD</label>
      <div class="value">{{ productMeta?.ibd }}</div>
    </div>

    <div class="summary-item">
      <label>DIBD</label>
      <div class="value">{{ productMeta?.dibd }}</div>
    </div>

  </ng-container>

    <!-- ACTIVITY LEVEL -->
  <ng-template  #activityBlock>

    <div class="summary-item">
    <label>Product Name</label>
    <div class="value">{{ metadata?.productName }}</div>
  </div>

  <div class="summary-item">
    <label>PSS Name</label>
    <div class="value">{{ metadata?.strategyName }}</div>
  </div>

  <div class="summary-item">
    <label>Version</label>
    <div class="value">{{ metadata?.version }}</div>
  </div>

  <div class="summary-item">
    <label>Activity Name</label>
    <div class="value">{{ metadata?.activityName }}</div>
  </div>

  <!-- <div class="summary-item">
    <label>Signal Creation Date</label>
    <div class="value">{{ today | date:'yyyy-MM-dd' }}</div>
  </div> -->
  </ng-template>

</div>


<form [formGroup]="form">
  <div class="grid-2">

    <mat-form-field appearance="outline">
      <mat-label>Signal Name</mat-label>
      <input matInput formControlName="signalName">
      <mat-error *ngIf="form.get('signalName')?.hasError('required')">
      Signal name is required
    </mat-error>
      <mat-error *ngIf="form.get('signalName')?.hasError('specialCharacter')">
      Special characters are not allowed
    </mat-error>
    </mat-form-field>

      <mat-form-field appearance="outline">
      <mat-label>Signal Status</mat-label>
      <mat-select formControlName="signalStatus">
              <mat-option *ngFor="let Status of SignalStatus" [value]="Status.lookupvalue">
                {{ Status.lookupvalue }}
              </mat-option>
      </mat-select>
          <mat-error *ngIf="form.get('signalStatus')?.hasError('required')">
     Signal Status is required
    </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Primary-Source</mat-label>

      <mat-select formControlName="primarySource">
        <ng-container *ngIf="SignalSources?.length > 0; else noOptions">
          <mat-option (click)="onCreateNewSourceClick($event)" class="CreateOption"   style="cursor: pointer;font-weight: 900;">  <em  class="fas fa-plus-circle" style="font-size: 16px;
                  padding: 0 5px;padding-left: 0;"></em>Create New Source
          </mat-option>
        <mat-divider></mat-divider>
          <mat-option *ngFor="let source of SignalSources" [value]="source.id">
            {{ source.name }}
          </mat-option>
        </ng-container>
      </mat-select>

      <ng-template #noOptions>
        <mat-option disabled>No options available</mat-option>
      </ng-template>

      <mat-error *ngIf="form.get('primarySource')?.hasError('required')">
        Primary-Source is required
      </mat-error>
    </mat-form-field>

        <mat-form-field appearance="outline">
      <mat-label>Secondary-Source</mat-label>

      <mat-select formControlName="secondarySource">
        <ng-container *ngIf="SignalSources?.length > 0; else noOptions">
          <mat-option (click)="onCreateNewSourceClick($event)" class="CreateOption"  style="cursor: pointer;font-weight: 900;">  <em  class="fas fa-plus-circle" style="font-size: 16px;
                  padding: 0 5px;padding-left: 0;"></em>Create New Source
          </mat-option>
        <mat-divider></mat-divider>
          <mat-option *ngFor="let source of SignalSources" [value]="source.id">
            {{ source.name }}
          </mat-option>
        </ng-container>
      </mat-select>

      <ng-template #noOptions>
        <mat-option disabled>No options available</mat-option>
      </ng-template>

      <mat-error *ngIf="form.get('secondarySource')?.hasError('required')">
        Secondary-Source is required
      </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Classification</mat-label>
      <mat-select formControlName="classification">
              <mat-option *ngFor="let classification of signalClassification" [value]="classification.lookupvalue">
                {{ classification.lookupvalue }}
              </mat-option>
      </mat-select>
          <mat-error *ngIf="form.get('classification')?.hasError('required')">
      Classification is required
    </mat-error>
    </mat-form-field>

    <!-- <mat-form-field appearance="outline" class="w-100">
  <mat-label>Medical Concept</mat-label>

  <input
    matInput
    formControlName="medicalConcept"
    [value]="form.get('medicalConcept')?.value"
    readonly
    (click)="openMedDraBrowser()"
    placeholder="Click to open MedDRA browser"
  >

  <mat-error *ngIf="form.get('medicalConcept')?.hasError('required')">
    Medical Concept is required
  </mat-error>
</mat-form-field> -->

    <!-- <mat-form-field appearance="outline">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
              <mat-option *ngFor="let signalPriority of signalPriority" [value]="signalPriority.lookupvalue">
                {{ signalPriority.lookupvalue }}
              </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('type')?.hasError('required')">
      Type is required
    </mat-error>
    </mat-form-field> -->


    <!-- <mat-form-field appearance="outline">
      <mat-label>Signal Priority</mat-label>
      <mat-select formControlName="signalPriority">
              <mat-option *ngFor="let signalPriority of signalPriority" [value]="signalPriority.lookupvalue">
                {{ signalPriority.lookupvalue }}
              </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('signalPriority')?.hasError('required')">
      Signal Priority is required
    </mat-error>
    </mat-form-field> -->

    <!-- <mat-form-field appearance="outline">
      <mat-label>Signal Creation Date</mat-label>
      <input matInput [matDatepicker]="picker1" formControlName="signalCreationDate">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="form.get('signalCreationDate')?.hasError('required')">
      Signal Creation Date is required
    </mat-error>
    </mat-form-field> -->

<mat-form-field appearance="outline">
  <mat-label>Signal Creation Date</mat-label>
  <input matInput
         [value]="form.get('signalCreationDate')?.value | date:'dd-MM-yyyy'"
         disabled>
</mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Signal Detected Date</mat-label>
      <input matInput [matDatepicker]="picker2" formControlName="signalDetectedDate"  readonly>
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
          <mat-error *ngIf="form.get('signalDetectedDate')?.hasError('required')">
      Signal Detected Date is required
    </mat-error>
    </mat-form-field>    

  </div>

<div class="two-column">
  <mat-form-field appearance="outline">
    <mat-label>Signal description</mat-label>
    <textarea matInput formControlName="signalDescription" rows="4"></textarea>

    <mat-error *ngIf="form.get('signalDescription')?.hasError('required')">
      Signal Description is required
    </mat-error>
    <mat-error *ngIf="form.get('signalDescription')?.hasError('specialCharacter')">
      Special characters are not allowed
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Reasoning / Justification</mat-label>
    <textarea matInput formControlName="justification" rows="4"></textarea>

    <mat-error *ngIf="form.get('justification')?.hasError('required')">
      Justification is required
    </mat-error>
    <mat-error *ngIf="form.get('justification')?.hasError('specialCharacter')">
      Special characters are not allowed
    </mat-error>
  </mat-form-field>
</div>


<!-- Hidden File Input -->
<!-- <input
  type="file"
  multiple
  #fileInput
  formControlName="attachments"
  (change)="onFileSelected($event)"
  hidden
/> -->

<!-- Upload UI Box -->
<!-- <div class="upload-box" (click)="fileInput.click()">
  <i class="fas fa-cloud-upload-alt upload-icon"></i>
  <p class="upload-text">Click to upload or drag & drop files here</p>
</div> -->

<!--  Error Shown Below -->
<!-- <div class="mat-error-custom"
     *ngIf="assessmentForm.get('attachments')?.invalid 
            && assessmentForm.get('attachments')?.touched">
  Attachment is required
</div> -->
  <!-- Attached File Chips -->
  <!-- <div *ngIf="uploadedFiles.length > 0" class="file-list">
    <mat-chip-list>
      <mat-chip *ngFor="let file of uploadedFiles" removable (removed)="removeFile(file)">
        <i class="fas fa-paperclip"></i> {{ file.name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div> -->
  <!-- Buttons -->
  <div class="actions">
  
    <!-- <button i18n="@@TMRunButton" type="button" (click)="onCancel()" [style.border-color]="backgroundColorButton"
     class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;" [style.border-color]="backgroundColorButton">Cancel</button> -->
     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="onCancel()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

     <!-- <button id="saveBtn" i18n="@@TMRunButton" type="button" (click)="onSubmit()" [style.background-color]="backgroundColorButton"
    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" style="padding: .3rem 1.6rem;">Submit</button> -->

    		     <app-common-button
 
          label="Submit"
 
          title="Submit "

          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="onSubmit()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

  </div>
</form>
